(() => {
  if (customElements.get('sauna-details-modal-controller')) return;
  customElements.define('sauna-details-modal-controller', class extends HTMLElement {});

  const SELECTOR = '[data-sauna-details-modal]';
  let activeModal = null;
  let opener = null;
  let activeSlide = 0;

  const focusable = (modal) => Array.from(modal.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'));

  function showSlide(index) {
    if (!activeModal) return;
    const slides = activeModal.querySelectorAll('[data-sauna-details-slide]');
    const dots = activeModal.querySelectorAll('[data-sauna-details-dot]');
    if (!slides.length) return;
    activeSlide = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === activeSlide));
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === activeSlide);
      dot.setAttribute('aria-current', i === activeSlide ? 'true' : 'false');
    });
  }

  function closeModal() {
    if (!activeModal) return;
    activeModal.hidden = true;
    document.body.classList.remove('sauna-details-modal-open');
    const previousOpener = opener;
    activeModal = null;
    opener = null;
    previousOpener?.focus();
  }

  function buildGallery(modal, images) {
    const gallery = modal.querySelector('[data-sauna-details-gallery]');
    gallery.replaceChildren();
    if (!images.length) return;
    const viewport = document.createElement('div');
    viewport.className = 'sauna-details-modal__viewport';
    images.forEach((image, index) => {
      const figure = document.createElement('figure');
      figure.className = 'sauna-details-modal__slide';
      figure.dataset.saunaDetailsSlide = '';
      figure.append(image.cloneNode(true));
      viewport.append(figure);
    });
    gallery.append(viewport);
    if (images.length > 1) {
      const controls = document.createElement('div');
      controls.className = 'sauna-details-modal__controls';
      controls.innerHTML = '<button type="button" class="sauna-details-modal__nav" data-sauna-details-previous aria-label="Previous image">Previous</button><div class="sauna-details-modal__dots" data-sauna-details-dots></div><button type="button" class="sauna-details-modal__nav" data-sauna-details-next aria-label="Next image">Next</button>';
      const dots = controls.querySelector('[data-sauna-details-dots]');
      images.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sauna-details-modal__dot';
        dot.dataset.saunaDetailsDot = String(index);
        dot.setAttribute('aria-label', `Show image ${index + 1} of ${images.length}`);
        dots.append(dot);
      });
      gallery.append(controls);
    }
  }

  function openModal(trigger) {
    const root = trigger.closest('[data-sauna-configurator]');
    const modal = root?.querySelector(SELECTOR);
    const template = root?.querySelector(`template[data-sauna-details-content="${CSS.escape(trigger.dataset.saunaDetailsTrigger || '')}"]`);
    if (!modal || !template) return;
    const content = template.content;
    modal.querySelector('[data-sauna-details-title]').textContent = content.querySelector('[data-title]')?.textContent || '';
    modal.querySelector('[data-sauna-details-description]').textContent = content.querySelector('[data-description]')?.textContent || '';
    let images = Array.from(content.querySelectorAll('img'));
    const isCube2Heater = trigger.dataset.saunaDetailsTrigger === 'heater' && root.querySelector('#cube2-calculator');
    if (isCube2Heater) images = images.slice(0, 1);
    buildGallery(modal, images);
    opener = trigger;
    activeModal = modal;
    modal.hidden = false;
    document.body.classList.add('sauna-details-modal-open');
    showSlide(0);
    modal.querySelector('[data-sauna-details-close]')?.focus();
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const trigger = target?.closest('[data-sauna-details-trigger]');
    if (trigger) { openModal(trigger); return; }
    if (!activeModal || !target?.closest(SELECTOR)) return;
    if (target.closest('[data-sauna-details-close]')) closeModal();
    else if (target.closest('[data-sauna-details-previous]')) showSlide(activeSlide - 1);
    else if (target.closest('[data-sauna-details-next]')) showSlide(activeSlide + 1);
    else {
      const dot = target.closest('[data-sauna-details-dot]');
      if (dot) showSlide(Number(dot.dataset.saunaDetailsDot));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!activeModal) return;
    if (event.key === 'Escape') { closeModal(); return; }
    if (event.key !== 'Tab') return;
    const items = focusable(activeModal);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (activeModal && event.target.contains(activeModal)) closeModal();
  });
})();
